export const INIT_CURRENT_RUBRIC = 'INIT_CURRENT_RUBRIC'
